import NotVerifiedView from "../views/loginStack/NotVerifiedView/NotVerifiedView";
import { useSelector } from "react-redux";
import AddModal from "../utilComponents/AddModal";
import { useEffect } from "react";

const WithVerifyMobileModal = (Component) => {
  const NewComponent = (args) => {
    const loginState = useSelector((state) => state.loginState);

    const isPhoneVerified = loginState?.login?.userInfo?.isPhoneVerified;

   

    return (
      <>
        <AddModal
          Component={({ openModal }) => (
            <Component {...args} openVerifyMobileModal={openModal} />
          )}
          ModalContent={({ closeModal, isModalFullyOpened, setError }) => {
            // //return SomeOtherComponent({isModalFullyOpened})  //odma mounta komponentu i ne dira ju kad otvaramo ne otvaramo modal
            // return <SomeOtherComponent isModalFullyOpened = {isModalFullyOpened} />;  //mounta komponentu iz pocetka svaki put kad otvorimo modal
            return (
              <>
                <NotVerifiedView
                  showHomePage={false}
                  PHONE
                  autoRelogin={false}
                  isInModal
                  modalFullyOpened={isModalFullyOpened}
                  setModalError={setError}
                />
              </>
            );
          }}
          modalCondition={!isPhoneVerified}
        />
      </>
    );
  };
  return NewComponent;
};

const SomeOtherComponent = ({isModalFullyOpened}) => {
  useEffect(() => {
    console.log("mounted SOC");

    return () => {
      console.log("unmounted SOC");
    };
  }, [isModalFullyOpened]);

  return <div>hejaaa</div>;
};

export default WithVerifyMobileModal;
